/*
* DatagridCalculatedField component specific for Adalia M&E.
*
* Calculate fields from datagrids - Use presets to define the calculation/filter logic. Functions in project context.
*
* Project can be passed as a prop, but if not, this component expects the document to contain an element with an id report-container
* and that element have a data-attribute called project-id.
*
*/

import React from 'react';
import update from 'immutability-helper';

import {fetchJson} from '../../../../helpers/fetch.js';
import Select from '../../../common/Select.jsx';

import Base from '../base.jsx'; 
import Helpers from '../helpers.jsx'
import Setting from "../setting.jsx";

import {
    Mode,
    castDataType,
    DataType
} from '../../common.jsx';

import { datagrid_results_as_per_preset_path } from '~/routes';

export default class AdaliaMeDatagridCalculatedField extends Base {
  static get CATEGORY() {
    return 'question';
  }

  static get TYPE() {
    return 'adalia_me_datagrid_calculated_field';
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: 'component_title_adalia_me_datagrid_calculated_field',
      description: 'field_default_description',
      help: null,
    };
  }

  static icon() {
    return <i className='fa fa-calculator'></i>;
  }

  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
      name: 'field_' + Helpers.randomString(),
    });
  }

  constructor(props) {
    super(props);

    this.state = {
      groupKeys: {},
      rowGroupCols: [],
      rows: {},
      calculatedValue: 0,
      loading: true
    }
  }

  componentDidMount() {
    super.componentDidMount();

    let project_id = this.props.project?.id || jQuery('#report-container').data('project-id');

    if (!project_id || [Mode.EDIT, Mode.SETTINGS].includes(this.props.mode)) {
      this.setState({
        groupKeys: {},
        rowGroupCols: [],
        rows: {},
        loading: false
      });

    } else {
      var answers = this.props.answers[this.props.content.name] || {};
      var selectedGroupKeys = [];

      Object.values(answers.groupKeys || {0: {selectedKey: null}}).forEach((groupKey, i) => {
        if(groupKey.selectedKey) selectedGroupKeys.push(groupKey.selectedKey);
        let selectedKeys = [...selectedGroupKeys];
        selectedKeys.pop();

        fetchOptionsForSelect(
          this.props.content.datagridId,
          this.props.content.presetId,
          project_id,
          this.context.programmeFormId,
          selectedKeys,
          this.getAnswer(),
          this.props.handleDisbursement,
          (res) => {
              if (res) {
                this.setState(prevState => {
                  return update(prevState, {
                    ['project_id']: {$set: project_id},
                    ['groupKeys']: {$set: (i == 0) ? answers.groupKeys || {} : prevState.groupKeys},
                    ['rowGroupCols']: {$set: (i == 0) ? res.rowGroupCols : prevState.rowGroupCols},
                    ['calculatedValue']: {$set: answers.calculatedValue},
                    ['rows']: {[i]: (obj) => update(obj || {}, {$set: res.rows})},
                    ['loading']: {$set: false}
                  })
                });
              }
            });
      });
    }
  }

  handleValueChange(col, gIndex, newValue) {
    var groupKeys = this.state.groupKeys;
    var selectedOption = this.getOptions(this.state.rows[gIndex], col).find(o => o.value == newValue);

    for(let i = gIndex; i < this.state.rowGroupCols.length; i++) delete groupKeys[i];
    this.state.groupKeys = groupKeys;

    this.setState(() => {
      return update(this.state, {
        ['groupKeys']: {
          [gIndex]: (obj) => update(obj || {}, {$merge: {selectedKey: selectedOption.value, selectedLabel: selectedOption.label}})
        },
        ['loading']: {$set: true}
      })
    }, () => {
      fetchOptionsForSelect(
        this.props.content.datagridId,
        this.props.content.presetId,
        this.state.project_id,
        this.context.programmeFormId,
        Object.values(this.state.groupKeys).map((v) => v.selectedKey),
        this.getAnswer(),
        this.props.handleDisbursement,
        (res) => {
            if (res) {
              this.setState(prevState => {
                return update(prevState, {
                  ['rows']: {
                    [gIndex+1]: (obj) => update(obj || {}, {$set: res.rows})
                  },
                  ['calculatedValue']: {$set: res.calculatedValue},
                  ['loading']: {$set: false}
                })
              });
            }
        });
    });
  }

  getOptions(rows, col) {
    return (rows || []).map(row => _.isObject(row[col.id]) ? {value: row[col.id].id, label: row[col.id].label} : {value: row[col.id], label: row[col.id]})
  }

  renderView() {
    return (
      <div>
        <label className={this.props.content.label_hidden ? 'hidden-label': ''}>
          <span className='field-label'>{this.getText('label')}</span>
          {this.helpIcon()}
          {this.descriptionText()}
        </label>

        { this.state.rowGroupCols.length == 0 ?
          <input className='form-control' readOnly/>
          :
          <div
            style={{
              backgroundColor: '#8880800a',
              border: '1px solid #00000033',
              borderRadius: '5px',
              boxShadow: '0 0 10px #00000033',
              padding: '3px 15px 15px',
              marginTop: '5px'
            }}
          >
            <div>
              {this.state.rowGroupCols.map((col, idx) => {
                let item = this.state.groupKeys[idx]||{};
                return <div key={col.id}>
                    <label className="w-100 mt-1">{col.displayName}</label>
                    <Select
                      name={this.fullFieldName() + `[groupKeys][${idx}]` + `[selectedKey]`}
                      value={item['selectedKey']}
                      options={this.getOptions(this.state.rows[idx], col)}
                      onChange={(v) => this.handleValueChange(col, idx, v)}
                      readOnly={this.props.mode != Mode.FILL}
                      disabled={this.props.disabled || this.props.mode != Mode.FILL}
                      autoComplete={this.getAutoComplete()}
                    />

                    <input name={this.fullFieldName() + `[groupKeys][${idx}]` + `[selectedLabel]`} value={item['selectedLabel']} type='hidden' />
                    <input name={this.fullFieldName() + `[groupKeys][${idx}]` + `[groupName]`} value={col.displayName} type='hidden' />
                  </div>
                }
              )}
            </div>

            <div className='mt-1'>
              <label className="w-100 mt-1">{this.props.content.label_for_calculated_field}</label>
              <input name={this.fullFieldName() + `[calculatedValue]`} className='form-control' value={this.state.calculatedValue} readOnly/>
            </div>
          </div>
        }
      </div>
    );
  }

  renderSettings() {
    return (
      <div>
        <div className="setting">
          <label>
            {I18n.t('component_name', {scope: 'fe'})}
          </label>
          <div className='option-groups'>
            {this.props.content.presetName}
          </div>
        </div>

        <Setting.TextField name='label' label={I18n.t('field_label', {scope: 'fe'})} value={this.getText("label")} onChange={this.updateSettings} />
        <Setting.Checkbox name='label_hidden' className='label-hidden-check' label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />
        <Setting.TextField name='label_for_calculated_field' label={I18n.t('label_for_calculated_field', {scope: 'fe'})} value={this.props.content.label_for_calculated_field} onChange={this.updateSettings} />
      </div>
    );
  }

  beforeUpdateSettings(content) {
    content.label_hidden = castDataType(content.label_hidden, DataType.BOOLEAN);
  }
}

const fetchOptionsForSelect = (datagrid_id, preset_id, project_id, programme_form_id, groupKeys, selected, handlingEnabled, cb) => {
  fetchJson(datagrid_results_as_per_preset_path({id: datagrid_id, datagrid_preset_id: preset_id, project_id: project_id, programme_form_id: programme_form_id, groupKeys: groupKeys, _options: true})).then(
    (res) => {
      cb(res);
    }
  )
};
